import React, { FC } from 'react';
import * as Styled from './dropdown-regions-item.styles';

interface DropdownRegionsItemProps {
    name: string;
}

export const DropdownRegionsItem: FC<DropdownRegionsItemProps> = ({ name }) => {
    return (
        <Styled.ItemContainer>
            <Styled.ShortName>
                {name}
            </Styled.ShortName>
        </Styled.ItemContainer>
    );
};
